"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  CONNECTED: 'connected',
  AUTHORIZATION_EXPIRED: 'authorization_expired',
  NOT_AUTHORIZED: 'not_authorized',
  UNKNOWN: 'unknown'
};
exports.default = _default;
//# sourceMappingURL=LoginStatus.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-facebook/lib/constants/LoginStatus.js
// module id = 203
// module chunks = 0